import { PropType, h, defineComponent } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '@frontend/state';
import BarButton from '@components/bar-button';
import {
    make_selected_coordinates_invisible,
    make_selected_coordinates_visible,
    selected_coordinates_visible,
} from '../../../state';
import selected_coordinates_svg from '../../../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/show_coordinates_selected.svg';
import { img } from '@phi/components';
import { ShowSelectedCoordinatesTooltip } from '../../tooltips/show-selected-coordinates-tooltip';

export const SelectedCoordinatesIcon = selected_coordinates_svg;

export const ShowSelectedCoordinates = defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show moving object coordinates';
        },

        disabled() {
            return !this.state.loaded;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return false;
            else if (selected_coordinates_visible.value)
                make_selected_coordinates_invisible();
            else
                make_selected_coordinates_visible();
        },
    },

    render() {
        return h(BarButton, {
            id: 'toggle-coordinates-selected-button',
            tippy: 'top',
            disabled: this.disabled,
            active: selected_coordinates_visible.value,
            selected: this.state.tut_stage === 3,
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(selected_coordinates_svg, this.alt),
            tooltip: ShowSelectedCoordinatesTooltip,
        });
    },
});
